// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__ttesQ","inputWrap":"CustomTip_inputWrap__3C_eI"};